import {DataBinder} from 'utils/data_binder'
export class TenDLCBrandModal extends HTMLElement {
  constructor(site) {
    super();
    this.site = site;
  }
  connectedCallback() {
    this.domain_id = document.querySelector("#object_id").value;
    if(this.site.tnid_brand == null) {
      this.renderSetupModal();
    } else {
      this.innerHTML = `
        <style>
          .ten_dlc_brand_enabled_row {
            font-size: 14px;
          }

          .ten-dlc-brand-detail-open:hover {
            cursor: pointer;
          }
        </style>
        <div class="ten_dlc_brand_enabled_row">
          <label class="fa-solid fa-check ten-dlc-enabled-icon"></label>
          <label>10DLC Enabled</label>
          <a class="fas fa-external-link ten-dlc-brand-detail-open"></a>
        </div>`;

      this.querySelector('.ten-dlc-brand-detail-open').addEventListener('click', function() {
        let detail = new TenDLCBrandDetail(this.domain_id);
        this.appendChild(detail);
      }.bind(this))
    }
    // this.setStep(1)
  }

  renderSetupModal() {
    let groups_with_tnid = this.site.auto_groups.filter((auto_group) => auto_group.tnid_organization_id != null).map(auto_group => `<option value="${auto_group.tnid_organization_id}">${auto_group.name}</option>`).join("")
    this.innerHTML = 
      `
      <style>
        ten-dlc-brand-modal .progressbar {
          display: flex;
          justify-content: center;
          padding-top: 20px;
        }

        ten-dlc-brand-modal .modal-dialog {
          height: 795px;
        }

        ten-dlc-brand-modal label {
          margin-top: 10px
        }

        ten-dlc-brand-modal .modal-content {
          z-index: 0;
        }

        #brand_ein::-webkit-outer-spin-button,
        #brand_ein::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        /* Firefox */
        #brand_ein[type=number] {
          -moz-appearance: textfield;
        }

        .modal_loading {
          height: 500px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
  
        .modal_loading img {
          height: 200px;
        }
      </style>
      <button class="btn btn-primary pull-right" id="ten-dlc-brand-button">Register Brand <span class="fa-solid fa-chevron-right"></span></button>
      <div class="modal fade bd-example-modal-sm" id="10DLCBrandModal" data-cy="" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4>10DLC Brand</h4>
            </div>
            <div class="modal-body">
              <div class="errors"></div>
              <ten-dlc-brand-steps></ten-dlc-brand-steps>
              <ul class="progressbar">
                <li class="active">Basic Info</li>
                <li>Contact Info</li>
              </ul>
              <div class="row" id="ten-dlc-brand-step1">
                <div class="col-sm-6">
                  <label>Partner Group</label>
                  <select id="brand_tnid_partner" class="form-control">
                    <option value="null">Select</option>
                    ${groups_with_tnid}
                  </select>
                  
                  <label>Display Name</label>
                  <input id="brand_display_name" type="text" class="form-control">
                  <label>Company Name</label>
                  <input id="brand_company_name" type="text" class="form-control">
                  <label>Tax ID/EIN Issuing Country</label>
                  <select id="brand_ein_issuing_country" class="form-control">
                    <option value="null">Select</option>
                    <option value="US">USA</option>
                    <option value="CA">Canada</option>
                  </select>
                  <label>Tax ID/EIN <span style="margin-left: 10px; font-weight: 100; font-size: 10px;"> * please remove all formatting (numbers only).</span></label>
                  <input id="brand_ein" type="number" class="form-control" maxlength="9">
                </div>
                <div class="col-sm-6">
                  <label>Brand Entity Type</label>
                  <select id="brand_entity_type" class="form-control">
                    <option value="null">Select</option>
                    <option value="PRIVATE_PROFIT">Private Profit</option>
                    <option value="PUBLIC_PROFIT">Public Profit</option>
                    <option value="NON_PROFIT">Non Profit</option>
                    <option value="GOVERNMENT">Government</option>
                  </select>
                  <label class="public_profit_required hidden">Stock Exchange</label>
                  <select id="brand_stock_exchange" class="form-control public_profit_required hidden">
                    <option value="null">Select</option>
                    <option value="NYSE">NYSE</option>
                  </select>
                  <label class="public_profit_required hidden">Stock Symbol</label>
                  <input id="brand_stock_symbol" class="form-control public_profit_required hidden"/>
                  <label>Brand Relationship</label>
                  <select id="brand_relationship" class="form-control">
                    <option value="BASIC_ACCOUNT">Basic Account</option>
                    <option value="SMALL_ACCOUNT">Small Account</option>
                    <option value="MEDIUM_ACCOUNT">Medium Account</option>
                    <option value="LARGE_ACCOUNT">Large Account</option>
                    <option value="KEY_ACCOUNT">Key Account</option>
                  </select>
                  <label>Vertical/Industry</label>
                  <select id="brand_vertical" class="form-control">
                    <option value="null">Select</option>
                    <option value="PROFESSIONAL">Professional</option>
                    <option value="REAL_ESTATE">Real Estate</option>
                    <option value="HEALTHCARE">Healthcare</option>
                    <option value="HUMAN_RESOURCES">Human Resources</option>
                    <option value="ENERGY">Energy</option>
                    <option value="ENTERTAINMENT">Entertainment</option>
                    <option value="RETAIL">Retail</option>
                    <option value="TRANSPORTATION">Transportation</option>
                    <option value="AGRICULTURE">Agriculture</option>
                    <option value="INSURANCE">Insurance</option>
                    <option value="POSTAL">Postal</option>
                    <option value="EDUCATION">Education</option>
                    <option value="HOSPITALITY">Hospitality</option>
                    <option value="FINANCIAL">Financial</option>
                    <option value="POLITICAL">Political</option>
                    <option value="GAMBLING">Gambling</option>
                    <option value="LEGAL">Legal</option>
                    <option value="CONSTRUCTION">Construction</option>
                    <option value="NGO">NGO</option>
                    <option value="MANUFACTURING">Manufacturing</option>
                    <option value="GOVERNMENT">Government</option>
                    <option value="TECHNOLOGY">Technology</option>
                    <option value="COMMUNICATION">Communication</option>
                  </select>
                </div>
                <div class="col-sm-12">
                  <button type="button" class="btn btn-primary ten-dlc-next pull-right detail-row-button" data-cy="">Next</button>
                  <button type="button" class="btn btn-outline-secondary pull-right detail-row-button" disabled>Previous</button>
                  <button type="button" class="btn btn-outline-secondary cancel pull-left detail-row-button">Cancel</button>
                </div>
              </div>
              <div class="row hidden" id="ten-dlc-brand-step2">
                <div class="col-sm-6">
                  <label>First Name</label>
                  <input id="brand_first_name" type="text" class="form-control" maxlength="72">
                  <label>Last Name</label>
                  <input id="brand_last_name" type="text" class="form-control" maxlength="72">
                  <label>Address</label>
                  <input id="brand_street" type="text" class="form-control" maxlength="72">
                  <label>City</label>
                  <input id="brand_city" type="text" class="form-control" maxlength="72">
                  <label>State</label>
                  <select id="brand_state" class="form-control">
                    <option value="null">Select</option>
                    <optgroup label="U.S. States/Territories">
                      <option value="AK">Alaska</option>
                      <option value="AL">Alabama</option>
                      <option value="AR">Arkansas</option>
                      <option value="AZ">Arizona</option>
                      <option value="CA">California</option>
                      <option value="CO">Colorado</option>
                      <option value="CT">Connecticut</option>
                      <option value="DC">District of Columbia</option>
                      <option value="DE">Delaware</option>
                      <option value="FL">Florida</option>
                      <option value="GA">Georgia</option>
                      <option value="HI">Hawaii</option>
                      <option value="IA">Iowa</option>
                      <option value="ID">Idaho</option>
                      <option value="IL">Illinois</option>
                      <option value="IN">Indiana</option>
                      <option value="KS">Kansas</option>
                      <option value="KY">Kentucky</option>
                      <option value="LA">Louisiana</option>
                      <option value="MA">Massachusetts</option>
                      <option value="MD">Maryland</option>
                      <option value="ME">Maine</option>
                      <option value="MI">Michigan</option>
                      <option value="MN">Minnesota</option>
                      <option value="MO">Missouri</option>
                      <option value="MS">Mississippi</option>
                      <option value="MT">Montana</option>
                      <option value="NC">North Carolina</option>
                      <option value="ND">North Dakota</option>
                      <option value="NE">Nebraska</option>
                      <option value="NH">New Hampshire</option>
                      <option value="NJ">New Jersey</option>
                      <option value="NM">New Mexico</option>
                      <option value="NV">Nevada</option>
                      <option value="NY">New York</option>
                      <option value="OH">Ohio</option>
                      <option value="OK">Oklahoma</option>
                      <option value="OR">Oregon</option>
                      <option value="PA">Pennsylvania</option>
                      <option value="PR">Puerto Rico</option>
                      <option value="RI">Rhode Island</option>
                      <option value="SC">South Carolina</option>
                      <option value="SD">South Dakota</option>
                      <option value="TN">Tennessee</option>
                      <option value="TX">Texas</option>
                      <option value="UT">Utah</option>
                      <option value="VA">Virginia</option>
                      <option value="VT">Vermont</option>
                      <option value="WA">Washington</option>
                      <option value="WI">Wisconsin</option>
                      <option value="WV">West Virginia</option>
                      <option value="WY">Wyoming</option>
                    </optgroup>
                    <optgroup label="Canadian Provinces">
                      <option value="AB">Alberta</option>
                      <option value="BC">British Columbia</option>
                      <option value="MB">Manitoba</option>
                      <option value="NB">New Brunswick</option>
                      <option value="NF">Newfoundland</option>
                      <option value="NT">Northwest Territories</option>
                      <option value="NS">Nova Scotia</option>
                      <option value="NU">Nunavut</option>
                      <option value="ON">Ontario</option>
                      <option value="PE">Prince Edward Island</option>
                      <option value="QC">Quebec</option>
                      <option value="SK">Saskatchewan</option>
                      <option value="YT">Yukon Territory</option>
                    </optgroup>
                  </select>
                  <label>Postal Code</label>
                  <input id="brand_postal_code" type="text" class="form-control" maxlength="10">
                  <label>Country</label>
                  <select id="brand_country_code" class="form-control">
                    <option value="null">Select</option>
                    <option value="US">USA</option>
                    <option value="CA">Canada</option>
                  </select>
                </div>
                <div class="col-sm-6">
                  <label>Commercial Email Address</label>
                  <input id="brand_commercial_email" type="text" class="form-control email">
                  <label>Commercial Phone Number</label>
                  <input id="brand_commercial_phone" type="text" class="form-control phone">
                  <label>Technical Email Address</label>
                  <input id="brand_technical_email" type="text" class="form-control email">
                  <label>Technical Phone Number</label>
                  <input id="brand_technical_phone" type="text" class="form-control phone">
                  <label>Financial Email Address</label>
                  <input id="brand_financial_email" type="text" class="form-control email">
                  <label>Financial Phone Number</label>
                  <input id="brand_financial_phone" type="text" class="form-control phone">
                </div>
                <div class="col-sm-12">
                  <button type="button" class="btn btn-primary save pull-right detail-row-button" data-cy="save-10-dlc">Save</button>
                  <button type="button" class="btn btn-outline-secondary pull-right detail-row-button ten-dlc-previous" data-step="2">Previous</button>
                  <button type="button" class="btn btn-outline-secondary cancel pull-left detail-row-button">Cancel</button>
                </div>
              </div>
              <div class="modal_loading hidden">
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      `;

    $(this).find(".phone").mask("(999) 999-9999")

    this.querySelector('#ten-dlc-brand-button').addEventListener('click', function(e) {
      e.preventDefault();
      $("#10DLCBrandModal").modal('show');
    }.bind(this))

    this.querySelector('.ten-dlc-previous').addEventListener('click', function(e) {
      this.setStep(e.target.dataset.step - 1);
    }.bind(this))
    this.querySelector('.ten-dlc-next').addEventListener('click', function() {
      if(this.validateStep1()) {
        this.setStep(2);
      }
    }.bind(this))

    this.querySelector("#brand_entity_type").addEventListener("change", (e) => {
      if(e.target.value == "PUBLIC_PROFIT") {
        this.querySelectorAll(".public_profit_required").forEach(function(elem) {
          elem.classList.remove("hidden");
        });
      } else {
        this.querySelectorAll(".public_profit_required").forEach(function(elem) {
          elem.classList.add("hidden");
        });
      }
    });

    this.querySelectorAll('.cancel').forEach(elem => {
      elem.addEventListener('click', function() {
        $("#10DLCBrandModal").modal('hide');
      }.bind(this))
    })
    this.querySelector('.save').addEventListener('click', function() {
      if(this.validateStep2()) {
        this.save();
      }
    }.bind(this))
  }

  setStep(step) {
    let currentActive = this.querySelector(".active")
    if(currentActive != null) {
      currentActive.classList.remove("active");
    }
    if(this.querySelector(`#ten-dlc-brand-step${step - 1}`)) {
      this.querySelector(`#ten-dlc-brand-step${step - 1}`).classList.add('hidden');
    }
    if(this.querySelector(`#ten-dlc-brand-step${step + 1}`)) {
      this.querySelector(`#ten-dlc-brand-step${step + 1}`).classList.add('hidden');
    }
    this.querySelector(`#ten-dlc-brand-step${step}`).classList.remove('hidden');

    this.querySelectorAll("li")[step-1].classList.add("active");
  }

  async save() {
    this.querySelector('#ten-dlc-brand-step2').classList.add('hidden');
    this.querySelector('.modal_loading').classList.remove('hidden');
    let brand = {
      "organizationId": this.querySelector("#brand_tnid_partner").value,
      "entityType":this.querySelector("#brand_entity_type").value,
      "firstName":this.querySelector("#brand_first_name").value,
      "lastName":this.querySelector("#brand_last_name").value,
      "displayName":this.querySelector("#brand_display_name").value,
      "companyName":this.querySelector("#brand_company_name").value,
      "ein":this.querySelector("#brand_ein").value,
      "einIssuingCountry":this.querySelector("#brand_ein_issuing_country").value,
      "commercialContactPhoneNumber":"+1"+this.querySelector("#brand_commercial_phone").value.replace(/\D/g,''),
      "technicalContactPhoneNumber":"+1"+this.querySelector("#brand_technical_phone").value.replace(/\D/g,''),
      "financialContactPhoneNumber":"+1"+this.querySelector("#brand_financial_phone").value.replace(/\D/g,''),
      "street":this.querySelector("#brand_street").value,
      "city":this.querySelector("#brand_city").value,
      "state":this.querySelector("#brand_state").value,
      "postalCode":this.querySelector("#brand_postal_code").value,
      "country":this.querySelector("#brand_country_code").value,
      "technicalContactEmail":this.querySelector("#brand_technical_email").value,
      "commercialContactEmail":this.querySelector("#brand_commercial_email").value,
      "financialContactEmail":this.querySelector("#brand_commercial_email").value,
      "brandRelationship":this.querySelector("#brand_relationship").value,
      "vertical":this.querySelector("#brand_vertical").value
    }

    if(brand.entityType == "PUBLIC_PROFIT") {
      brand.stockSymbol = this.querySelector("#brand_stock_symbol").value
      brand.stockExchange = this.querySelector("#brand_stock_exchange").value
    }

    this.querySelector(".errors").innerHTML = "";

    let res = await fetch(`/admin/domains/${this.site.domain_id}/10dlc`, {
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-type': 'application/json'},
      method: 'POST',
      body: JSON.stringify(brand)
    })

    let response = await res.json();
    if(res.ok) {
      $("#10DLCBrandModal").modal('hide');
      let data_binder = new DataBinder(`/admin/domains/${this.site.domain_id}.json`, true);
      await data_binder.fetchData();
    } else {
      this.querySelector('#ten-dlc-brand-step2').classList.remove('hidden');
      this.querySelector('.modal_loading').classList.add('hidden');
      this.querySelector(".errors").innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> An unknown error occured trying to save your brand.
                                                  </div>`
    }
    
  }

  validateStep1() {
    return this.validateInputs(this.querySelector("#ten-dlc-brand-step1"))
  }

  validateStep2() {
    return this.validateInputs(this.querySelector("#ten-dlc-brand-step1")) && this.validateInputs(this.querySelector("#ten-dlc-brand-step2"))
  }

  validateInputs(wrapperElem) {
    let found_errors = false;
    wrapperElem.querySelectorAll("input, textarea").forEach(function(elem) {
      elem.classList.remove("error");
      if(elem.offsetParent != null && elem.value == "") {
        found_errors = true;
        elem.classList.add("error");
      }
    });

    wrapperElem.querySelectorAll("select").forEach(function(elem) {
      elem.classList.remove("error");
      if(elem.offsetParent != null && elem.value == "null") {
        found_errors = true;
        elem.classList.add("error");
      }
    });

    wrapperElem.querySelectorAll("input.email").forEach(function(elem) {
      elem.classList.remove("error");
      if(elem.offsetParent != null && !Common.validateEmail(elem.value)) {
        found_errors = true;
        elem.classList.add("error");
      } 
    })

    return !found_errors;
  }
}

customElements.define('ten-dlc-brand-modal', TenDLCBrandModal)

class TenDLCBrandDetail extends HTMLElement {
  constructor(domain_id) {
    super();
    this.domain_id = domain_id;
  }
  async connectedCallback() {
    this.loadingWheel();
    $("#10DLCBrandDetail").modal('show');
    let res = await fetch(`/admin/domains/${this.domain_id}/10dlc`);
    let data = await res.json();
    if(data.error) {
      Common.notify('Sorry, there was an error loading 10DLC Brand', 'error');
      return
    }
    let vertical = data.vertical.split('_').map(str => {
      return str[0] + str.substring(1).toLowerCase()
    }).join(' ');
    this.querySelector('.modal-body').innerHTML = 
      `
      <div class="row">
        <div class="col-sm-6">
          <label>First Name</label>
          <p>${data.firstName}</p>
          <label>Last Name</label>
          <p>${data.lastName}</p>
          <label>Company Name</label>
          <p>${data.companyName}</p>
          <label>Street</label>
          <p>${data.street}</p>
          <label>City</label>
          <p>${data.city}</p>
          <label>State</label>
          <p>${data.state}</p>
          <label>Postal Code</label>
          <p>${data.state}</p>
          <label>Country</label>
          <p>${data.country}</p>
        </div>
        <div class="col-sm-6">
          <label>Commercial Phone Number</label>
          <p>${data.commercialContactPhoneNumber}</p>
          <label>Commercial Email Address</label>
          <p>${data.commercialContactEmail}</p>
          <label>Technical Phone Number</label>
          <p>${data.technicalContactPhoneNumber}</p>
          <label>Technical Email Address</label>
          <p>${data.technicalContactEmail}</p>
          <label>Financial Phone Number</label>
          <p>${data.financialContactPhoneNumber}</p>
          <label>Financial Email Address</label>
          <p>${data.financialContactEmail}</p>
          <label>Vertical/Industry</label>
          <p>${vertical}</p>
        </div>
      </div>
      <div class="col-sm-12">
        <button type="button" class="btn btn-danger delete pull-right detail-row-button">Delete</button>
        <button type="button" class="btn btn-outline-secondary cancel pull-right detail-row-button">Close</button>
      </div>
      `;

    this.querySelector('.close').addEventListener('click', function() {
      this.remove();
    }.bind(this))

    this.querySelector('.cancel').addEventListener('click', function() {
      this.querySelector('.close').click();
    }.bind(this))

    this.querySelector('.delete').addEventListener('click', async function() {
      this.querySelector('.close').click();
      if(await confirmPlus(`Are you sure you want to delete this 10DLC Brand?`)) {
        this.deleteBrand()
      }
    }.bind(this))
  }

  loadingWheel() {
    this.innerHTML = `
    <div class="modal fade bd-example-modal-sm" id="10DLCBrandDetail" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">10DLC Detail</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="modal_loading">
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  async deleteBrand() {
    let res = await fetch(`/admin/domains/${this.domain_id}/10dlc`, {
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-type': 'application/json'},
      method: 'DELETE'
    })

    let response = await res.json();
    if(res.ok) {
      let data_binder = new DataBinder(`/admin/domains/${this.domain_id}.json`, true);
      await data_binder.fetchData();
    } else {
      console.log("UNABLE TO DELETE")
    }
  }
}

customElements.define('ten-dlc-brand-detail', TenDLCBrandDetail)